/**
 * @license lucide-react v0.484.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["circle", {
  cx: "12",
  cy: "12",
  r: "3",
  key: "1v7zrd"
}], ["path", {
  d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
  key: "14wa3c"
}], ["path", {
  d: "M12 7.5V9",
  key: "1oy5b0"
}], ["path", {
  d: "M7.5 12H9",
  key: "eltsq1"
}], ["path", {
  d: "M16.5 12H15",
  key: "vk5kw4"
}], ["path", {
  d: "M12 16.5V15",
  key: "k7eayi"
}], ["path", {
  d: "m8 8 1.88 1.88",
  key: "nxy4qf"
}], ["path", {
  d: "M14.12 9.88 16 8",
  key: "1lst6k"
}], ["path", {
  d: "m8 16 1.88-1.88",
  key: "h2eex1"
}], ["path", {
  d: "M14.12 14.12 16 16",
  key: "uqkrx3"
}]];
var Flower = createLucideIcon("flower", __iconNode);
export { __iconNode, Flower as default };